import {useEffect, useState} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router-dom';
import Information from './Information';
import Error from '../common/Error';
import Container from '../common/layout/Container';
import {useAppDispatch} from '../../store/hooks';
import {MatchParams} from '../../constants/types';
import useFetch from '../../hooks/useFetch';
import {setTitle} from '../../store/header/header.slice';
import Tabs from '../common/Tabs';
import UnsortableList from '../common/UnsortableList';
import AddToTenant from '../common/tenants/AddToTenant';
import permissionsInfo from '../../constants/permissionsInfo';
import Spinner from '../common/Spinner';
import EnsurePermission from '../common/EnsurePermission';
import {DEFAULT_ERROR} from '../../api/constants';
import {useTranslation} from 'react-i18next';

const getTabs = (path: string) => ([
  {
    name: 'Information',
    link: path,
    permissions: null
  },
  {
    name: 'Tenants',
    link: `${path}/tenants`,
    permissions: permissionsInfo.groups.list.tenants
  },
  {
    name: 'Users',
    link: `${path}/users`,
    permissions: permissionsInfo.groups.list.users
  }
]);

const EditGroup = () => {
  const {t} = useTranslation('groups');
  const dispatch = useAppDispatch();
  const {url, params, path}: MatchParams = useRouteMatch();
  const {id} = params || {};
  const [groupName, setGroupName] = useState('');

  const [data, isLoading, error] = useFetch(`/groups/${id}`);

  useEffect(() => {
    dispatch(setTitle(''));
  }, []);

  useEffect(() => {
    if (data) setGroupName(data?.name);
  }, [data]);

  if (error) {
    return <Error message={error?.message || DEFAULT_ERROR} />;
  }

  return (
    <Container header="System Configuration - Groups">
      {!isLoading ? (
        <>
          <h2 className="subheader">Edit Group - {groupName}</h2>
          <Tabs tabs={getTabs(url)} />

          <Switch>
            <Route exact path={url}>
              <Information id={id} apiData={data} setGroupName={setGroupName}/>
            </Route>

            <Route exact path={`${url}/tenants`}>
              <EnsurePermission
                elementPermissions={permissionsInfo.groups.list.tenants}
                showError={true}>
                <AddToTenant
                  id={id}
                  name={groupName}
                  entityKey={`${path}/tenants`}
                  toastTitle={t('toasts.toastTitle')}/>
              </EnsurePermission>
            </Route>

            <Route exact path={`${url}/users`}>
              <EnsurePermission
                elementPermissions={permissionsInfo.groups.list.tenants}
                showError={true}>
                <UnsortableList
                  id={id}
                  name={groupName}
                  entityKey={`${path}/users`}/>
              </EnsurePermission>
            </Route>
          </Switch>
        </>
      ) : <Spinner loadingText="Getting group info" />}
    </Container>
  );
};

export default EditGroup;
